/**
 * @param   {String} stringWithAt
 * @returns {String}
 */
export default function withoutAt(stringWithAt) {
  const lastAtIndex = stringWithAt.indexOf("@");

  return lastAtIndex >= 0
    ? stringWithAt.substring(lastAtIndex + 1, stringWithAt.length)
    : stringWithAt;
}
